import React from 'react';
import { TooltipWrapper } from '@uikit/TooltipWrapper';

interface ReportTitleInfoProps {
  title: React.ReactNode;
  tooltip?: string;
  titleStyle?: React.CSSProperties;
}

export const ReportTitleInfo = ({
  title,
  tooltip,
  titleStyle
}: ReportTitleInfoProps) => (
  <span
    className="reports-title-info"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      maxWidth: '100%',
      minWidth: 0,
    }}
  >
    <span style={{ whiteSpace: 'nowrap', ...titleStyle }}>{title}</span>
    {tooltip && (
      <span style={{ display: 'inline-flex', flex: '0 0 auto' }}>
        <TooltipWrapper tooltip={tooltip}>
          <span
            className="reports-title-info-icon"
            aria-label={`${typeof title === 'string' ? title : 'Report'} information`}
            style={{
              display: 'inline-flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: 10,
              height: 10,
              minWidth: 10,
              minHeight: 10,
              flexShrink: 0,
              borderRadius: '50%',
              backgroundColor: '#ffffff',
              color: '#000000',
              fontSize: 9,
            }}
          >
            i
          </span>
        </TooltipWrapper>
      </span>
    )}
  </span>
);
